<template>
    <div class="work-list">
        <div v-for="requirement in requirementList" class="work-progress">
            <el-row class="base-info">
                <el-col :span="6" class="cover-wrapper">
                    <img :src="`${UPLOAD_IMG_HOST}${requirement.bookRequirement.coverPath}`" class="cover">
                </el-col>
                <el-col :span="12" class="content-wrapper">
                    <el-row class="book-name-col">
                        <span class="book-name">{{ requirement.bookRequirement.requirementName }}</span>
                        <span class="work-status">{{ getRequirementStatus(requirement.bookRequirement.requirementViewStatus) }}</span>
                    </el-row>
                    <el-row class="anchor-share-pay-col">
                        <span class="share-label" v-if="requirement.bookRequirement.pay.royaltyShareRatio && !requirement.bookRequirement.pay.prePay">{{ $t('word.sharePay') }} </span>
                        <span class="share-label" v-if="requirement.bookRequirement.pay.prePay && !requirement.bookRequirement.pay.royaltyShareRatio">{{ $t('word.basePrice') }}</span>
                        <span class="share-label" v-if="requirement.bookRequirement.pay.prePay && requirement.bookRequirement.pay.royaltyShareRatio">{{ $t('word.basePrice') }} + {{ $t('word.sharePay') }}</span>
                        <span v-if="requirement.bookRequirement.pay.royaltyShareRatio">{{ Math.round(requirement.bookRequirement.pay.royaltyShareRatio*100) }}%</span>
                        <span v-if="requirement.bookRequirement.pay.royaltyShareRatio && requirement.bookRequirement.pay.prePay">+</span>
                        <span v-if="requirement.bookRequirement.pay.prePay">{{ requirement.bookRequirement.pay.prePay.direct.multiplier}}{{requirement.bookRequirement.pay.prePay.unit}}</span>
                    </el-row>
                    <el-row>
                        <pre>{{ $t('comb.taskCategory') }}:  {{ requirement.bookRequirement.categoryLabel }}</pre>
                    </el-row>
                    <el-row v-if="requirement.bookRequirement.requirement">
                        <pre>{{ $t('comb.taskRequirement') }}:  {{ requirement.bookRequirement.requirement}}</pre>
                    </el-row>
                    <el-row>
                        <pre>{{ $t('comb.recruitmentAmount') }}:  {{ requirement.bookRequirement.userCount }}</pre>
                    </el-row>
                    <el-row>
                        <pre>{{ $t('comb.releaseMode') }}:  {{ requirement.bookRequirement.demandDistributionOption }}</pre>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="time-line-wrapper">
                <el-steps :space="130" :align-center="true">
                    <el-step v-for="node in requirement.bookRequirement.timeNodeList" :description="getEvent(node.event, node.message)" :title="formatDate(node.time)"></el-step>
                </el-steps>
            </el-row>
            <el-row class="task-wrapper" v-if="requirement.requirementAlbum">
                <el-col :xs="8" :sm="{span:5,offset:1}" :md="{span:5,offset:1}" :lg="{span:5,offset:1}" class="task-info">
                    <span>{{ $t('comb.transcribed') }}</span>
                    <span>{{ requirement.requirementAlbum.trackCount }}</span>
                </el-col>
                <el-col :xs="8" :sm="{span:5,offset:1}" :md="{span:5,offset:1}" :lg="{span:5,offset:1}" class="task-info">
                    <span>{{ $t('comb.buyAmount') }}</span>
                    <span>{{ requirement.requirementAlbum.subscribeCount }}</span></el-col>
                <el-col :xs="8" :sm="{span:5,offset:1}" :md="{span:5,offset:1}" :lg="{span:5,offset:1}" class="task-info">
                    <span>{{ $t('comb.played') }}</span>
                    <span>{{ requirement.requirementAlbum.playCount }}</span></el-col>
            </el-row>
            <el-row class="anchor-list" v-if="requirement.requirementAnchor">
                <span class="list-label">{{ $t('word.anchor') }}</span>
                <el-row class="anchor">
                    <img :src="getHeaderPic(requirement.requirementAnchor.headPic)">
                    <div class="content">
                        <a :href="getHref(requirement.requirementAnchor.userId)">{{ requirement.requirementAnchor.nickname }}</a>
                        <span>{{ $t('comb.goodAt') }}：<b v-for="skill in requirement.requirementAnchor.skills"> {{ skill }} </b></span>
                    </div>
                </el-row>
            </el-row>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import moment from 'moment';

    export default {
        components: {

        },
        data() {
            return {
                requirementList: [],
                steps: [],
                report: {},
                anchors: []
            }
        },
        beforeMount() {
            this.init();
        },
        methods: {
            init() {
                // 根据 params: id 获得requirement基本信息、节点信息、任务信息和主播信息
                const that = this;
                axios.get(`/api/books/requirements/${this.$route.params.id}`).then((res) => {
                    that.requirementList = res.data.data;
                });
            },
            getRequirementStatus(status) {
                let label = '';
                switch (status) {
                    case 1:;
                    case 2: label = this.$i18n.t('word.selecting');break;
                    case 3: label = this.$i18n.t('word.inProduction');break;
                    case 4: label = this.$i18n.t('word.finished');break;
                }
                return label;
            },
            getHeaderPic(url) {
                return url? this.UPLOAD_IMG_HOST + url: 'http://s1.xmcdn.com/css/img/common/default/user110.jpg';
            },
            getHref(id) {
                return this.$store.state.XMLY_INDEX_URL +'zhubo/'+ id;
            },
            formatDate(date) {
                return moment(date).format('YYYY-MM-DD');
            },
            getEvent(event, message) {
                return message? event+'/'+message: event;
            }
        },
        computed: {
            UPLOAD_IMG_HOST() {
                return this.$store.state.UPLOAD_IMG_HOST;
            },
        }
    }
</script>
<style lang="sass">
    @import "../../../sass/copyright/workProgress.scss";
</style>



// WEBPACK FOOTER //
// WorkProgress.vue?19dc5aa0